<template>
    <div v-if="workspaceInvitationModel" class="container">
        <br /><br />
        <div class="jumbotron">
            <h1 class="display-4">Invitation to workspace {{ workspaceName }}</h1>
            <p class="lead">
                You were invited to workspace
                <strong>{{ workspaceName }}</strong>
                owned by
                <strong>{{ organizationName }}</strong>
                in TransparentChoice application
            </p>
            <hr>

            <button @click="handleAcceptWorkspaceInvitationCommandV1"
                    class="btn btn-success text-white mr-2"
                    style="padding: 0.7em 2em;">
                <i class="fa fa-check" aria-hidden="true"></i>
                Accept invitation
            </button>

            <button @click="handleRejectWorkspaceInvitationCommandV1"
                    class="btn btn-secondary text-white"
                    style="padding: 0.7em 2em;">
                <i class="fa fa-ban" aria-hidden="true"></i>
                Reject invitation
            </button>
        </div>
    </div>

    <div v-else>
        <h4>Loading...</h4>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted } from 'vue'
    import { useRoute, useRouter } from 'vue-router'

    import { useWorkspaceInvitationQueryV1 } from '@Organizations/Workspaces/queries-vue-composables'
    import { useAcceptWorkspaceInvitationCommandV1, useRejectWorkspaceInvitationCommandV1 } from '@Organizations/Workspaces/commands-vue-composables'

    /* router */

    const route = useRoute()
    const router = useRouter()
    const token = route.params.token as string

    /* query */

    const {
        modelWorkspaceInvitationQueryV1: model,
        runWorkspaceInvitationQueryV1
    } = useWorkspaceInvitationQueryV1(token)

    /* derived */

    const workspaceInvitationModel = computed(() => model.value)
    const workspaceId = computed(() => workspaceInvitationModel.value?.WorkspaceId)
    const workspaceName = computed(() => workspaceInvitationModel.value?.WorkspaceName)
    const organizationName = computed(() => workspaceInvitationModel.value?.OrganizationName)
    const recipientEmail = computed(() => workspaceInvitationModel.value?.RecipientEmail)

    /* commands */

    const {
        invokeAcceptWorkspaceInvitationCommandV1,
        onSucceedAcceptWorkspaceInvitationCommandV1
    } = useAcceptWorkspaceInvitationCommandV1(workspaceId, recipientEmail)

    const {
        invokeRejectWorkspaceInvitationCommandV1,
        onSucceedRejectWorkspaceInvitationCommandV1
    } = useRejectWorkspaceInvitationCommandV1(workspaceId, recipientEmail)


    /* lifecycle */

    onMounted(() =>
    {
        document.title = `Invitation to workspace ${workspaceName.value ?? ''}`
        runWorkspaceInvitationQueryV1()
    })

    /* success handling */

    onSucceedAcceptWorkspaceInvitationCommandV1(() =>
    {
        router.push('/organizations/users/dashboard')
    })

    onSucceedRejectWorkspaceInvitationCommandV1(() =>
    {
        router.push('/organizations/users/dashboard')
    })

    /* handlers */

    function handleAcceptWorkspaceInvitationCommandV1()
    {
        if (!workspaceId.value || !recipientEmail.value) return
        invokeAcceptWorkspaceInvitationCommandV1();
    }

    function handleRejectWorkspaceInvitationCommandV1()
    {
        if (!workspaceId.value || !recipientEmail.value) return
        invokeRejectWorkspaceInvitationCommandV1();
    }
</script>


